import type { DefineStoreOptions, StateTree } from "pinia";
export function defineStoreGetters<
  Id extends string,
  S extends StateTree,
  G,
  A,
>(
  _: { id: Id; state: () => S },
  getters: DefineStoreOptions<Id, S, G, A>["getters"],
) {
  return getters;
}

export function defineStoreActions<
  Id extends string,
  S extends StateTree,
  G,
  A,
>(
  _: { id: Id; state: () => S; getters: G },
  actions: DefineStoreOptions<Id, S, G, A>["actions"],
) {
  return actions;
}
